/* global axios */
import ApiClient from './ApiClient';

class ComposeTeamAPI extends ApiClient {
  constructor() {
    super('compose_team', { accountScoped: true });
    this.cachedTeams = null;
    this.cachedAccountId = null;
  }

  getTeams() {
    const accountId = this.accountIdFromRoute;
    if (this.cachedAccountId !== accountId) {
      this.cachedTeams = null;
      this.cachedAccountId = accountId;
    }
    if (!this.cachedTeams) {
      this.cachedTeams = axios
        .get(`${this.url}/teams`)
        .then(({ data }) => data.payload || [])
        .catch(() => []);
    }
    return this.cachedTeams;
  }
}

export default new ComposeTeamAPI();
